const widgets = document.querySelectorAll(".js-tabs");
[...widgets].forEach(widget => {
	widget.addEventListener("click", showTabOnDropdownAction, false);
	widget.addEventListener("click", updateDropdownOnTabAction, false);
});

function showTabOnDropdownAction({ target }) {
	const trigger = target.closest(".js-item");
	if (!trigger) return;

	const id = trigger.getAttribute("data-controls");
	const tabTrigger = document.getElementById(id);
	if (tabTrigger) tabTrigger.click();
}

function updateDropdownOnTabAction({ target }) {
	const trigger = target.closest(".js-trigger");
	if (!trigger) return;

	const dropdownTrigger = trigger
		.closest(".js-tabs")
		.querySelector(".js-trigger");
	if (dropdownTrigger) dropdownTrigger.innerHTML = trigger.innerHTML;
}
